import { createSelector } from 'reselect';
import { MVT_WEB_POSTCODES, MVT_1175 } from '../flags/experiments';
import { WEB_POSTCODES_DISABLED, NEW_ADDRESS_FLOW_ENABLED } from '../flags/features';
import { whichVariant, isFeatureActive } from './configSelectors';

const getDefaultLocationSearch = (state) => state.request.country.postcodeSearch;
const getPostcodeSearchMVT = (state) => whichVariant(state, MVT_WEB_POSTCODES);
const getPostcodesDisabledFlag = (state) => isFeatureActive(state, WEB_POSTCODES_DISABLED);
const getAddressFlowMVT = (state) => whichVariant(state, MVT_1175);
const getNewAddressFlowEnabledFlag = (state) => isFeatureActive(state, NEW_ADDRESS_FLOW_ENABLED);

export const getIsPostcodeSearch = createSelector(
  [getDefaultLocationSearch, getPostcodeSearchMVT, getPostcodesDisabledFlag],
  (isPostcodeSearch, postcodeSearchVariant, postcodesDisabled) => {
    if (postcodesDisabled) return false;

    /*
        If the MVT isn't active then return the default postcode search value from app/config.js
        Otherwise check the variant value to determine if the user should see postcode search or geolocation search.
    */
    if (!postcodeSearchVariant) return isPostcodeSearch;

    if (postcodeSearchVariant === 'use_postcodes') {
      return true;
    }
    return false;
  },
);

export const getIsNewAddressFlow = createSelector(
  [getIsPostcodeSearch, getNewAddressFlowEnabledFlag, getAddressFlowMVT],
  (isPostcodeSearch, newAddressFlowEnabled, addressFlowVariant) => {
    if (!isPostcodeSearch && newAddressFlowEnabled) return true;

    return !isPostcodeSearch && addressFlowVariant === 'new';
  },
);
